/*
 * Contact Form 7 — multiple file attachments.
 *
 * CF7's native [file] tag only ever handles a single file, so a
 * ".form__row--file" row stacks a few [file] fields (your-file, your-file-2, ...)
 * as ".form__file-item" slots, each backed by its own <input type="file">.
 *
 * The chosen files are tracked as one array (independent of which physical
 * input they started in). Removing a file splices it out and shifts the rest
 * up — including the first slot — so there's never a gap between filled slots,
 * and only one empty slot ever shows after the last filled one. Since each
 * slot's <input> maps to a distinct CF7 field name, "shifting" means
 * reassigning File objects across inputs via the DataTransfer API (the only
 * way to set input.files programmatically).
 *
 * The empty-state text is read from "data-no-file-text" on ".form__row--file"
 * (set it directly in the CF7 form content) so it can be translated per language
 * instead of being hardcoded here. Long file names are truncated for display.
 */

const NO_FILE_TEXT = "Nie wybrano pliku";
const NAME_MAX_LENGTH = 20;

const truncateName = (name) =>
    name.length > NAME_MAX_LENGTH ? `${name.slice(0, NAME_MAX_LENGTH)}...` : name;

export const contactFormFiles = () => {
    document.querySelectorAll(".form__row--file").forEach((row) => {
        const noFileText = row.dataset.noFileText || NO_FILE_TEXT;

        const slots = Array.from(row.querySelectorAll(".form__file-item"))
            .map((item) => ({
                item,
                input: item.querySelector('input[type="file"]'),
                nameEl: item.querySelector(".form__file-item__name"),
                removeButton: item.querySelector(".form__file-item__remove"),
            }))
            .filter((slot) => slot.input);

        if (!slots.length) return;

        const files = slots.map(() => null);

        const render = () => {
            let lastFilled = -1;
            files.forEach((file, index) => {
                if (file) lastFilled = index;
            });

            slots.forEach((slot, index) => {
                const file = files[index];

                // input.files is read-only; DataTransfer is the only way to set it
                const transfer = new DataTransfer();
                if (file) transfer.items.add(file);
                slot.input.files = transfer.files;

                slot.item.classList.toggle("has-file", Boolean(file));
                if (slot.nameEl) {
                    slot.nameEl.textContent = file ? truncateName(file.name) : noFileText;
                }

                const visible = index === 0 || index <= lastFilled + 1;
                slot.item.classList.toggle("is-hidden", !visible);
            });
        };

        slots.forEach((slot, index) => {
            slot.input.addEventListener("change", () => {
                files[index] = (slot.input.files && slot.input.files[0]) || null;
                render();
            });

            if (slot.removeButton) {
                slot.removeButton.addEventListener("click", () => {
                    files.splice(index, 1);
                    files.push(null);
                    render();
                });
            }
        });

        render();
    });
};
